/*global _ */
import axios from 'axios'
import {getFirstErrorMessage, getErrorMessage, getErrorMessages, getErrorMessagesWithKeys} from '~/lib/axios'
import config from '../lib/config'
import {handlePromise} from '../lib/utils'
import {root as rootSetting} from '../lib/settings'
export const { apiEndpoints = {}, services = {} } = rootSetting

export const {CONFIG: {apiUri: APIURI, clientSecret: client_secret,  clientId: client_id}} = config

export const promise = async (name, handler)  => await handlePromise(name, handler, getFirstErrorMessage)
export const setPromise = async (name, handler)  => {
  if (/^main\.?/i.test(_.get(services, name, 'Main'))) {
    return await promise(name, handler)
  }
}

export const getEndpoint = (options, defaultValue) => {
  options = options || {}
  defaultValue = defaultValue || ''
  return options.absoluteEndPoint || (APIURI + (options.endPoint || defaultValue))
}

export const registerUser = async (payload, options = {}) => {
  const endPoint = getEndpoint(options, _.get(apiEndpoints, 'user.registration', '/user/register'))
  const {data} = await axios.post(endPoint, payload)
  return data
}
setPromise('user.registration', registerUser)

export const sendConfirmation = async (payload, options = {}) => {
  // {email}
  const endPoint = getEndpoint({}, _.get(apiEndpoints, 'user.confirmRegistration', '/user/register/resend'))
  const {data} = await axios.post(endPoint, payload)
  return data
}
setPromise('user.registration.resend-confirmation', sendConfirmation)

export const loginUser = async (request, options = {}) => {
  // {email, reseturl}
  const scope = ''
  const payload = {client_id, client_secret, scope, ...request || {}}
  const endPoint = getEndpoint(options, _.get(apiEndpoints, 'user.login', '/clients/api/login'))
  const {data} = await axios.post(endPoint, payload)
  return data
}
setPromise('user.login', loginUser)

export const forgotPassword = async (payload, options = {}) => {
  // {email, reseturl}
  const endPoint = getEndpoint(options, _.get(apiEndpoints, 'password.forgot', '/user/password/forgot'))
  const {data} = await axios.post(endPoint, payload)
  return data
}
setPromise('user.password.forgot', forgotPassword)

export const resetPassword = async (payload, options = {}) => {
  // {email, reseturl}
  const endPoint = getEndpoint(options, _.get(apiEndpoints, 'password.reset', '/user/password/reset'))
  const {data} = await axios.post(endPoint, payload)
  return data
}
setPromise('user.password.reset', resetPassword)


export const emailVerify = async (payload, options = {}) => {
  // {email, token}
  const endPoint = getEndpoint(options, _.get(apiEndpoints, 'user.email.verify', '/user/email-verification/check'))
  const {data} = await axios.post(endPoint, payload)
  return data
}
setPromise('user.email.verify', emailVerify)

export const updateUser = async (id, payload, options = {}) => {
  const endPoint = getEndpoint(options, _.get(apiEndpoints, 'user.update', `/user/${id}`))
  const {data} = await axios.put(endPoint, payload)
  return data
}
setPromise('user.update', updateUser)

export const notifyOrder = async (id, options = {}) => {
  const endPoint = getEndpoint(options, _.get(apiEndpoints, 'user.order.notify', `/customer/order/${id}/notify`))
  const {data} = await axios.get(endPoint)
  return data
}
setPromise('user.order.notify', notifyOrder)

export const validateEmail = async (payload, options = {}) => {
  const endPoint = getEndpoint(options, _.get(apiEndpoints, 'user.email.validate', `/user/register/validate-email`))
  const {data} = await axios.post(endPoint, payload)
  return data
}
setPromise('user.validate.email', validateEmail)

export const validateOrder = async (payload, options = {}) => {
  const endPoint = getEndpoint(options, _.get(apiEndpoints, 'user.order.validate', `/customer/order/validate`))
  const {data} = await axios.post(endPoint, payload)
  return data
}
setPromise('user.validate.order', validateOrder)

export const order = async (payload, options = {}) => {
  const endPoint = getEndpoint(options, _.get(apiEndpoints, 'user.order.purchase', `/customer/order`))
  const {data} = await axios.post(endPoint, payload)
  return data
}
setPromise('shop.order', order)

export const validateAuth = async (options = {}) => {
  const endPoint = getEndpoint(options, _.get(apiEndpoints, 'user.ping', `/api/v1/user/ping`))
  try {
    const {data} = await axios.post(endPoint)
    return true
  } catch (e) { }
  return false
}
setPromise('user.ping', validateAuth)

export {
  axios,
  getFirstErrorMessage,
  getErrorMessage,
  getErrorMessages,
  getErrorMessagesWithKeys,
  handlePromise,
}

export default {
  axios,
  getFirstErrorMessage,
  getErrorMessage,
  getErrorMessages,
  getErrorMessagesWithKeys,
  apiEndpoints,
  services,

  getEndpoint,
  promise,
  handlePromise,
  setPromise,

  registerUser,
  sendConfirmation,
  loginUser,
  forgotPassword,
  notifyOrder,
  updateUser,
  validateEmail,
  validateOrder,
  order,
  validateAuth
}
